import { CampaignType } from 'generated-graphql/types';

type GetCustomJobPostingUrlProps = {
  campaignType: CampaignType;
  portalUrl: string | undefined;
  atsJobPostingUrl: string | undefined | null;
  candidateBatchCustomJobPostingUrl: string | undefined | null;
  formCustomJobPostingUrl: string | undefined | null;
};

type GetCustomJobPostingUrlOutput = {
  showCustomJobPostingUrlError: boolean;
  customJobPostingUrl: string | undefined;
};

export const getSourcingSharedCustomJobPostingUrl = ({
  campaignType,
  portalUrl,
  atsJobPostingUrl,
  candidateBatchCustomJobPostingUrl,
  formCustomJobPostingUrl
}: GetCustomJobPostingUrlProps): GetCustomJobPostingUrlOutput => {
  if (campaignType === CampaignType.RequestCvOutreach) {
    return {
      showCustomJobPostingUrlError: false,
      customJobPostingUrl: undefined
    };
  }

  if (campaignType === CampaignType.CustomJobApplicationUrlOutreach) {
    if (portalUrl) {
      return {
        showCustomJobPostingUrlError: false,
        customJobPostingUrl: portalUrl
      };
    }

    if (candidateBatchCustomJobPostingUrl) {
      return {
        showCustomJobPostingUrlError: false,
        customJobPostingUrl: candidateBatchCustomJobPostingUrl
      };
    }

    if (formCustomJobPostingUrl) {
      return {
        showCustomJobPostingUrlError: false,
        customJobPostingUrl: formCustomJobPostingUrl
      };
    }

    return {
      showCustomJobPostingUrlError: true,
      customJobPostingUrl: undefined
    };
  }

  if (campaignType === CampaignType.AtsJobApplicationUrlOutreach) {
    if (atsJobPostingUrl) {
      return {
        showCustomJobPostingUrlError: false,
        customJobPostingUrl: atsJobPostingUrl
      };
    }

    return {
      showCustomJobPostingUrlError: true,
      customJobPostingUrl: undefined
    };
  }

  return {
    showCustomJobPostingUrlError: true,
    customJobPostingUrl: undefined
  };
};
